import { Component, computed, inject, Input } from '@angular/core';
import { CommonModule, formatCurrency, formatDate, formatPercent, KeyValuePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { MatPrefix } from '@angular/material/form-field';
import { Store } from '@ngxs/store';
import { CamelToSentencePipe } from '@app/app/pipes/camel-to-sentence.pipe';
import { GridTopBottomIdentifier } from '@app/app/components/businesses/finances/grid-top-bottom-identifier.directive';
import { DebtScheduleState } from '@app/app/store/debt-schedule/debt-schedule.state';
import { DebtScheduleItemDialogComponent } from '../debt-schedule-item-dialog/debt-schedule-item.dialog.component';
import { AuthState } from '@app/app/store/auth/auth.state';

@Component({
  selector: 'app-finances-debt',
  imports: [
    CommonModule,
    CamelToSentencePipe,
    GridTopBottomIdentifier,
    KeyValuePipe,
    MatButtonModule,
    MatIconModule,
    MatPrefix
  ],
  templateUrl: './finances-debt.component.html',
  styleUrl: './finances-debt.component.scss'
})
export class FinancesDebtComponent {
  @Input() debtContext: 'business' | 'personal' | undefined;
  private _store = inject(Store);
  private _dialog = inject(MatDialog)
  canEditDscrData = this._store.selectSignal(AuthState.userHasPermission('lpxDscrData.write'));
  debtScheduleItems = this._store.selectSignal(DebtScheduleState.debtScheduleItems);
  debtScheduleItemsData = computed(() => {
    const items = this.debtScheduleItems();
    return items.map(item => {
      const {
        isDebtConsolidation,
        isSBALoan,
        created,
        modified,
        loanStartDate,
        currentBalance,
        paymentAmount,
        paymentFrequency,
        term,
        originalBalance,
        interestRate,
        debtType,
        borrowerId,
        deleted,
        ...remaining
      } = item;

      const formattedCreated = created ? formatDate(created, 'shortDate', 'en-US') : '-';
      const formattedModified = modified ? formatDate(modified, 'short', 'en-US') : '-';
      const formattedLoanStartDate = loanStartDate ? formatDate(loanStartDate, 'shortDate', 'en-US') : '-';
      const formattedCurrentBalance = currentBalance ? formatCurrency(Number(currentBalance), 'en-US', '$') : '-';
      const formattedPaymentAmount = paymentAmount ? formatCurrency(Number(paymentAmount), 'en-US', '$') : '-';
      const formattedOriginalBalance = originalBalance ? formatCurrency(Number(originalBalance), 'en-US', '$') : '-';
      const formattedInterestRate = interestRate ? formatPercent(interestRate / 100, 'en-US', '1.2-2') : '-';
      const formattedDebtType = CamelToSentencePipe.format(debtType);
      const formattedPaymentFrequency = CamelToSentencePipe.format(paymentFrequency);

      return {
        ...remaining,
        created: formattedCreated,
        currentBalance: formattedCurrentBalance,
        debtConsolidation: isDebtConsolidation ? 'Yes' : 'No',
        debtType: formattedDebtType,
        interestRate: formattedInterestRate,
        loanStartDate: formattedLoanStartDate,
        modified: formattedModified,
        originalBalance: formattedOriginalBalance,
        paymentAmount: formattedPaymentAmount,
        paymentFrequency: formattedPaymentFrequency,
        sbaLoan: isSBALoan ? 'Yes' : 'No',
        term: term ? `${term} months` : '-'
      };
    });
  });

  editDebtScheduleItem(itemId: number) {
    const items = this.debtScheduleItems();
    const debtScheduleItem = items.find(item => item.id === itemId);
    debtScheduleItem && this._dialog.open(DebtScheduleItemDialogComponent, {
      width: '700px',
      maxHeight: '720px',
      autoFocus: false,
      data: {
        ...debtScheduleItem
      },
    });
  }

  newDebtScheduleItem() {
    this._dialog.open(DebtScheduleItemDialogComponent, {
      width: '700px',
      maxHeight: '720px',
      autoFocus: false,
    });
  }

}
